export default {
  // 數據分析
  data_analysis: {
    viewdata: '查看數據',
    adapterDevice: '適配設備',
    exit: '退出',
    fullScreen: '全屏',
    preview: '預覽',
    today: '今日',
    update: '更新',
    chartNoDate: '圖表無數據',
    addChart: '添加圖表',
    fenpeiShare: '分配共享',
    allFilter: '全局篩選',
    cilckCancelLinkage: '點擊取消聯動',
    allFilterSet: '全局篩選設置',
    screen: '篩選',
    chartLinkageSet: '圖表聯動設置',
    timeUpdateSet: '定時刷新設置',
    copyChart: '復制圖表',
    editChart: '編輯圖表',
    chartLinkage: '圖表聯動',
    timeUpdate: '定時刷新',
    personnel: '人員',
    minAddOneChart: '請至少添加壹個圖表',
    dataChangeIfSave: '數據發生改變，需要保存嗎?',
    saveOkReturn: '保存成功，正在返回...',
    shareToMe: '分享給我的',
    addReport: '新增數據分析',
    noNameChart: '未命名圖表',
    dataIsNormal: '數據正常',
    time: '時間',
    statistical: '統計',
    dimension: '維度',
    editShowName: '修改顯示名稱',
    dimensionColumn: '維度(列)',
    value: '數值',
    editFiledName: '修改字段名稱',
    subtotal: '小計',
    total: '合計',
    sum: '求和',
    average: '平均值',
    min: '最小值',
    max: '最大值',
    count: '計數',
    repeatCount: '去重計數',
    dataFormat: '數據格式',
    useYear: '按年',
    useHalfYear: '按半年',
    useQuarter: '按季度',
    useMounth: '按月',
    useWeek: '按周',
    useDay: '按日',
    useDepartment: '按部門',
    usePersonnel: '按人',
    sort: '排序',
    default: '默認',
    asc: '升序',
    desc: '降序',
    alignment: '對齊方式',
    left: '左對齊',
    center: '居中',
    chartName: '圖表名稱',
    right: '右對齊',
    show: '顯示',
    chartType: '圖表類型',
    assistSet: '輔助設置',
    align: '對齊',
    remarkColor: '標記顏色',
    warningSet: '預警設置',
    numberOfEntries: '條目數',
    showTiaoshu: '顯示條數',
    pageSet: '翻頁設置',
    tableSet: '表格設置',
    chartSet: '圖例設置',
    showSet: '顯示設置',
    showTag: '顯示標簽',
    showValue: '顯示數值',
    showPercent: '顯示百分比',
    chartScreenSet: '圖內篩選設置',
    range: '範圍',
    targetValue: '目標值',
    addOption: '添加項',
    filterSet: '過濾條件設置',
    highCondition: '高級條件',
    addScreenCondition: '添加篩選條件',
    juLeft: '居左',
    juRight: '居右',
    top: '頂部',
    bottom: '底部',
    customerLevel: '客戶等級',
    principal: '負責人',
    before: '前',
    after: '後',
    targetValueAfterMax: '目標值後面的值必須大於前面的值',
    max8Option: '最多只能添加8項',
    dataSource: '數據源',
    moveUnderFieldToValue: '可將下面字段拖入到維度/數值中',
    field: '字段',
    addField: '添加字段',
    sureDelField: '確定要刪除該字段嗎?',
    fieldNameMust: '字段名稱必填',
    themeStyle: '主題樣式',
    pureColor: '純色',
    picture: '圖片',
    custom: '自定義',
    chartColor: '圖表配色',
    borderSet: '邊框設置',
    color: '顏色',
    borderType: '線段類型',
    borderWidth: '線段寬度',
    white: '白',
    grey: '灰',
    blue: '藍',
    yellow: '黃',
    black: '黑',
    purple: '紫',
    pleaseAddFormula: '請添加公式',
    pleaseAddFormula1: '公式內容不能為空',
    operator: '運算符',
    returnType: '返回類型',
    decimalDigits: '小數位數',
    precision: '精確度',
    dayu: '大於',
    xiaoyu: '小於',
    dengyu: '等於',
    budengu: '不等於',
    dayudengyu: '大於等於',
    xiaoyudengyu: '小於等於',
    weikong: '為空',
    buweikong: '不為空',
    number: '數字',
    integer: '整數',
    percent: '百分比',
    rounded: '四舍五入',
    quweifa: '去尾法',
    jinyifa: '進壹法',
    noFengefu: '無分隔符',
    qianFengefu: '千分位分隔符',
    wanFengefu: '萬分位分隔符',
    sameDataSource: '相同數據源，不需要設置聯動字段',
    setMainLinkage: '請設置與主圖表聯動的字段',
    guanlianFieldNotEmpty: '關聯字段不能為空',
    selectedField: '已選字段',
    addField1: '已添加字段',
    contion: '條件',
    screenContion: '篩選條件',
    showColor: '顯示顏色',
    pleaseInputName: '請輸入名稱',
    refreshRate: '刷新頻率',
    enter5Interger: '請輸入大於5的整數',
    seconds: '秒',
    minute: '分',
    hour: '時',
    selectChartDataSource: '請選擇圖表數據源',
    qiehuanClear: '切換數據源將清空該圖表所有設置',
    sureQiehuan: '確定要切換嗎?',
    yes: '是',
    no: '否',
    highlight: '高亮顯示',
    contionSetError: '條件設置有誤',
    screenOption: '篩選項',
    selectScreenChart: '請選擇需要篩選的圖表',
    selectScreenField: '請選擇作為篩選項的字段',
    zhishaoSelectOneChart: '請選擇作為篩選項的字段',
    haveFilterEmpty: '存在為空的篩選項字段',
    nameNotRepeat: '名稱不允許重復',
    enterDsign: '進入設計',

    // 2020-10-15
    multiChartCalculation: '多圖表計算',
    chartNumber: '圖表-數字圖',
    leftAddFormula: '請從左側數字圖表中添加公式字段',
    showChartType: '顯示圖表類型',
    chartNameMustFill: '圖表名稱必填',
    tongbiHuanbi: '同比環比',
    tongbi: '同比',
    huanbi: '環比',
    huanbiUpValue: '環比增長值',
    huanbiUpLv: '環比增長率',
    lastWeekTBValue: '上周同比值',
    lastWeekTBLv: '上周同比率',
    lastMonthTBValue: '上月同比值',
    lastMonthTBLv: '上月同比率',
    lastYearTBValue: '上年同比值',
    lastYearTBLv: '上年同比率',
    showChartCount: '顯示圖內統計',
    analysisFormulaTip1: '函數中只能添加數字和日期組件',
    analysisFormulaTip2: '函數中只能添加數字組件',
    chooseRequiredAnd: '請選擇需要與',
    linkageChart: '聯動的圖表',
    DimensionRequired: '維度必填',
    startTimeRequired: '開始時間必填',
    endTimeRequired: '結束時間必填',
    DimensionValueNotValue: '維度和數值不能同時為空',
    progress: '進度',
    listFields: '列表字段',
    dontDragExistingField: '不能拖入已存在的字段',
    dragTimeCompent: '請拖入時間組件',
    dragValeCompent: '請拖入數字組件',
    GanttMaxDimension: '甘特圖的維度字段不能大於三個',
    Timescale: '時間刻度',
    chartDisplaySetting: '圖形顯示字段設置',
    quarter: '季度',
    FirstQuarter: '壹季度',
    SecondQuarter: '二季度',
    ThirdQuarter: '三季度',
    FourthQuarter: '四季度',
    January: '1月',
    February: '2月',
    March: '3月',
    April: '4月',
    May: '5月',
    June: '6月',
    July: '7月',
    August: '8月',
    September: '9月',
    October: '10月',
    November: '11月',
    December: '12月',
    theTimeScale: '時間刻度',

    // 2021-03-15
    ganttTimeTips: '開始時間必須小於或等於結束時間，否則圖表顯示為空',

    chartScreen: '圖內篩選',
    linkage: '聯動',
    viewSourceData: '查看原始數據',
    addKanban: '添加看板',
    group: '分組',
    searchReportDesc: '搜索報表、報表描述',
    dataUpdataBy: '數據更新至',
    kanbanName: '看板名稱',
    fromGroup: '所屬分組',
    tips: '溫馨提示',
    addGroup_tips1: '上下拖動分組進行排序，可點擊編輯名稱',
    addGroup_tips2: '有看板的分組不可刪除',
    groupKanban: '分組內看板',
    sourDelGroup: '確定要刪除該分組嗎？',
    kanbanNameMust: '看板名稱必填',
    groupNameMust: '所屬分組必填',
    layoutContainer: '布局容器',
    appearanceSetting: '外觀設置',
    ApplyTemplate: '套用模板',
    width: '寬',
    height: '高',
    column: '列',
    cell: '格',
    editKanban: '編輯看板',
    growthValue: '增長值',
    growthRate: '增長率',
    contraRatio: '對比值',
    nonameLayout: '未命名布局容器',
    noSelectSource: '未選擇數據源',
    chartStyle: '圖表樣式',
    dashboardStyle: '儀表盤樣式',
    styleSetTips1: '請選擇左側圖表進行設置',
    styleSetTips2: '按住Ctrl/Command+鼠標點選」可批量選擇圖表設置',
    showTitle: '顯示標題',
    layoutName: '布局名稱',
    layoutStyle: '布局樣式',
    backgroundOpacity: '背景透明度',
    titleAlign: '標題對齊',
    chartInnerFont: '圖內字體',
    showBorder: '顯示邊框',
    allDefaultColor: '默認整體配色',
    thisBatchSet: '此設置為批量修改設置，點擊後不可以恢復',
    dashboardAllset: '儀表盤整體',
    allBackground: '整體背景',
    allChartsStyle: '圖表樣式',
    titleBckground: '標題背景',
    colorPlan: '配色方案',
    gradation: '漸變',
    tableTypeCharts: '表格類圖表',
    chartMainColor: '圖表主色',
    titleFontColor: '表頭文字',
    contentText: '內容文字',
    point: '點',
    colorSetOptions1: '默認配色',
    colorSetOptions2: '經典配色',
    colorSetOptions3: '優雅格調',
    colorSetOptions4: '黨政/教務',
    colorSetOptions5: '溫馨暖調',
    colorSetOptions6: '潮流綠紫',
    colorSetOptions7: '智慧商務',
    colorSetOptions8: '智慧金融',
    colorSetOptions9: '科技商務',
    colorSetOptions10: '天空',
    colorSetOptions11: '熱情',
    colorSetOptions12: '清新',
    colorSetOptions13: '日光',
    colorSetOptions14: '神秘',
    colorSetOptions15: '檸檬',
    colorSetOptions16: '極光',
    functionConfig: '功能配置',
    dateField: '日期字段',
    valueSet: '數值設置',
    selectDate: '所選日期',
    sourceData: '原始數據',
    layoutSelect: '布局選擇',
    valueCardSize: '數值卡尺寸',
    miniCard: '小指標卡',
    maxCard: '大指標卡',
    iconLocation: '圖標位置',
    iconColor: '圖標顏色',
    sideStrip: '側邊條',
    mapColor: '地圖顏色',
    valueAlign: '數值對齊',
    themeColor: '主題顏色',
    lastWeekTb: '上周同比',
    lastMonthTb: '上月同比',
    lastYearTb: '去年同比'
  }
}
